import script from "./ClipperPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipperPlayer.vue?vue&type=script&setup=true&lang=js"

import "./ClipperPlayer.vue?vue&type=style&index=0&id=046fdef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046fdef4"]])

export default __exports__